import { useState, useEffect } from 'react'

export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 900) // Adjust the breakpoint as per your needs
    }

    window.addEventListener('resize', handleResize)
    handleResize() // Check on initial render

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return isMobile
}
